<ng-container *ngIf="state$ | async as state">
    <div class="options-overlay" [class.open]="state.open" (click)="close()"></div>
    <div class="options-panel" [class.open]="state.open">
        <div class="panel-header">
            <span class="panel-title">{{ state.title }}</span>
            <button class="panel-close" (click)="close()" aria-label="Close">
                <i class="pi pi-times"></i>
            </button>
        </div>
        <ul class="panel-options">
            <li *ngFor="let item of state.items">
                <button (click)="invoke(item)">
                    <app-custom-icon
                        *ngIf="item.iconName"
                        [iconPath]="'assets/icons/general-icons.svg'"
                        [imageName]="item.iconName"
                        [imageSize]="item.imageSize || '24'">
                    </app-custom-icon>
                    <h6>{{ item.label }}</h6>
                </button>
            </li>
        </ul>
    </div>
</ng-container>
